import { Box } from '@spark-web/box';
import { Text } from '@spark-web/text';

type Props = {
  items: Array<{
    symbol?: string;
    message: string;
  }>;
};

function StepFooter({ items }: Props) {
  if (!items) return null;

  return (
    <Box flexDirection="column">
      {items.map(({ symbol, message }) => (
        <Box display="flex" paddingY="medium" paddingX="small" gap="medium" key={message}>
          {symbol ? (
            <Text as="sup" tone="muted">
              {symbol}
            </Text>
          ) : null}
          <Text tone="muted" size="small">
            {message}
          </Text>
        </Box>
      ))}
    </Box>
  );
}

export default StepFooter;
